import Hammer from 'hammerjs'
import renderer from './renderer'
import config from './config'
import _ from 'underscore'
import {TweenMax, Cubic} from 'gsap'


// STATE
export let state = {
  px: 0,
  velocity: 1,

  swipeVelocity: 0,
  baseVelocity: config.velocityMin,

  multiplier: 1,

  swipes: [],
  sps: 0,

  inactive: false
}
const initialState = Object.assign({}, state)

let interval

// MANAGER
function onSwipe (evt) {
  const now = performance.now()
  state.swipes.push(now)
  state.swipeVelocity += Math.min(Math.abs(evt.overallVelocityY), 35)
  state.baseVelocity += config.swipeAddVelocity
  state.baseVelocity = Math.min(state.baseVelocity, config.maxBaseVelocity)
  resetInactive()
}
export let mc = new Hammer.Manager(renderer.domElement)
mc.add(new Hammer.Swipe())


let inactiveInterval
const resetInactive = function () {
  state.inactive = false
  clearInterval(inactiveInterval)
  inactiveInterval = setInterval(()=> {
    state.inactive = true
  }, config.helpTime)
}




// const updateSps = _.throttle(()=> {
//   const now = performance.now()
//   state.swipes = _.filter(state.swipes, (time) => {
//     return time > (now - 1000)
//   })
//   state.sps = Math.min(state.swipes.length, 12)
// }, 100)

// METHODS

export const update = function (delta) {

  // SPS
  const now = performance.now()
  state.swipes = _.filter(state.swipes, (time) => {
    return time > (now - 1000)
  })
  state.sps = Math.min(state.swipes.length, 18)

  // SWIPE VELOCITY
  if (state.swipeVelocity > 0.001) {
    state.swipeVelocity *= 0.96
  } else {
    state.swipeVelocity = 0
  }
  state.swipeVelocity = Math.min(state.swipeVelocity, 120)

  // BASE VELOCITY
  if (state.sps <= 1 && state.baseVelocity > config.velocityMin) {
    state.baseVelocity *= 0.99
  }


  // OUTPUT
  // state.velocity = Math.pow((state.baseVelocity + state.swipeVelocity * 0.3 + state.sps * 1) * 1, 1.5)
  state.velocity = (state.baseVelocity + state.swipeVelocity * 0.2 + Math.pow(state.sps, 0.75))
  state.velocity *= config.controlsMultiplier
  state.px += state.velocity * delta * state.multiplier
  // console.log(state.sps)
}

export const reset = function (delta) {
  state = Object.assign({}, initialState)
}

export const stop = function (time = 2) {
  return new Promise((resolve)=> {
    TweenMax.to(state, time, {
      multiplier: 0,
      ease: Cubic.easeIn,
      onComplete: resolve
    })
  })
}

export const destroy = function () {
  mc.off('swipe', onSwipe)
  clearInterval(state.inactiveInterval)
}

export const setMultiplier = function(val) {
  state.multiplier = val
}


let autoInterval
export const startAuto = function (sps = 2.5) {
  clearInterval(autoInterval)
  autoInterval = setInterval(()=> {
    onSwipe({overallVelocityY: 20})
  }, 1000 / sps)
}


export const init = function () {
  destroy()
  reset()
  mc.on('swipe', onSwipe)
  resetInactive()

}



// WEBPACK FOOTER //
// ./src/components/game/controls.js